import type { CardProps } from '@sravni/react-design-system/dist/types/components/Card';

import type { OfferCard } from './Card';
import accidentInsuranceImg from './imgs/accident-insurance.svg';
import creditCardImg from './imgs/credit-card.svg';
import creditImg from './imgs/credit.svg';
import absoluteImg from './imgs/logos/absolut-strah.png';
import aebImg from './imgs/logos/aeb.png';
import alfaImg from './imgs/logos/alfa.png';
import alfaStrahImg from './imgs/logos/alfa_strah.png';
import asianImg from './imgs/logos/asian-bank.png';
import auto2creditImg from './imgs/logos/auto2credit.png';
import dozpImg from './imgs/logos/dozp.png';
import ezaimImg from './imgs/logos/ezaim.png';
import homeImg from './imgs/logos/home.png';
import ingostrahImg from './imgs/logos/ingostrah.png';
import moneymanImg from './imgs/logos/Moneyman.png';
import monezaImg from './imgs/logos/Moneza.png';
import mtsImg from './imgs/logos/mts-bank.png';
import otkritieImg from './imgs/logos/otkritie.png';
import platizaImg from './imgs/logos/Platiza.png';
import pochtaImg from './imgs/logos/pochta.png';
import renessansImg from './imgs/logos/renessans.svg';
import resoImg from './imgs/logos/reso.png';
import rosbankImg from './imgs/logos/rosbank.png';
import rosgosstrahImg from './imgs/logos/rosgosstrah.png';
import standartImg from './imgs/logos/rus-standart.png';
import sberImg from './imgs/logos/sber.png';
import soglasieImg from './imgs/logos/soglasie.png';
import tinkoffImg from './imgs/logos/tinkoff.png';
import vskImg from './imgs/logos/vsk.png';
import vtbImg from './imgs/logos/vtb.png';
import yugoriaImg from './imgs/logos/yugoria.svg';
import zaimRfImg from './imgs/logos/zaim_rf.png';
import mfoImg from './imgs/mfo.svg';
import mortgageInsuranceImg from './imgs/mortgage-insurance.svg';
import osagoImg from './imgs/osago.svg';
import propertyInsuranceImg from './imgs/property-insurance.svg';
import travelInsuranceImg from './imgs/travel-Insurance.svg';

export const MFO_PARTNERS_IMGS = [
  { alias: 'ezaim', ...ezaimImg },
  { alias: 'moneyman', ...moneymanImg },
  { alias: 'dozp', ...dozpImg },
  { alias: 'moneza', ...monezaImg },
  { alias: 'platiza', ...platizaImg },
  { alias: 'auto2credit', ...auto2creditImg },
  { alias: 'aeb', ...aebImg },
  { alias: 'zaimRf', ...zaimRfImg },
];
export const OSAGO_PARTNERS_IMGS = [
  { alias: 'alfaStrah-img', ...alfaStrahImg },
  { alias: 'sber-img', ...sberImg },
  { alias: 'rosgosstrah-img', ...rosgosstrahImg },
  { alias: 'ingostrah-img', ...ingostrahImg },
  { alias: 'vsk-img', ...vskImg },
  { alias: 'soglasie-img', ...soglasieImg },
  { alias: 'renessans-img', ...renessansImg },
];
export const CREDIT_PARTNERS_IMGS = [
  { alias: 'alfa-img', ...alfaImg },
  { alias: 'otkritie-img', ...otkritieImg },
  { alias: 'rosbank-img', ...rosbankImg },
  { alias: 'pochta-img', ...pochtaImg },
  { alias: 'home-img', ...homeImg },
];

export const TRAVEL_INSURANCE_IMGS = [
  { alias: 'reso-logo', ...resoImg },
  { alias: 'rosgosstrah-logo', ...rosgosstrahImg },
  { alias: 'sber-logo', ...sberImg },
  { alias: 'soglasie-logo', ...soglasieImg },
  { alias: 'tinkoff-logo', ...tinkoffImg },
  { alias: 'ingostrah-logo', ...ingostrahImg },
  { alias: 'absolute-logo', ...absoluteImg },
  { alias: 'alfaStrah-logo', ...alfaStrahImg },
  { alias: 'vtb-logo', ...vtbImg },
];

export const ACCIDENT_INSURANCE_IMGS = [
  { alias: 'standart-logo', ...standartImg },
  { alias: 'ingostrah-logo', ...ingostrahImg },
  { alias: 'absolute-logo', ...absoluteImg },
  { alias: 'alfaStrah-logo', ...alfaStrahImg },
];

export const PROPERTY_INSURANCE_IMGS = [
  { alias: 'alfaStrah-logo', ...alfaStrahImg },
  { alias: 'yugoria-logo', ...yugoriaImg },
  { alias: 'renessans-logo', ...renessansImg },
  { alias: 'soglasie-logo', ...soglasieImg },
  { alias: 'absolute-logo', ...absoluteImg },
];

export const MORTGAGE_INSURANCE_IMGS = [
  { alias: 'soglasie-logo', ...soglasieImg },
  { alias: 'ingostrah-logo', ...ingostrahImg },
  { alias: 'alfaStrah-logo', ...alfaStrahImg },
  { alias: 'vsk-logo', ...vskImg },
  { alias: 'rosgosstrah-logo', ...rosgosstrahImg },
];

export const CREDIT_CARD_IMGS = [
  { alias: 'alfa-logo', ...alfaImg },
  { alias: 'tinkoff-logo', ...tinkoffImg },
  { alias: 'mts-logo', ...mtsImg },
  { alias: 'asian-logo', ...asianImg },
];

export const cards: (React.ComponentProps<typeof OfferCard> & { id: number })[] = [
  {
    id: 1,
    title: 'МФО',
    desc: [
      'Выгодные офферы по оформлению займов\nонлайн на карту от МФО с суммой до 100 000 ₽.',
      'Более 40 офферов по топовым МФО\nс высокой конверсией из заявки в выдачу',
    ],
    short: 'Выгодные офферы по оформлению займов онлайн от МФО с суммой до 100 000 ₽',
    image: mfoImg,
    reward: {
      amount: 'до 5000 ₽',
    },
    partnersImgs: MFO_PARTNERS_IMGS,
  },
  {
    id: 2,
    title: 'ОСАГО',
    desc: [
      'Сервис подбора и моментальной покупки\nполисов ОСАГО для быстрого и выгодного оформления полиса.',
      'Возможность увеличения продаж за счет предложения клиентам кросс-продуктов',
    ],
    short: 'Сервис подбора и моментальной покупки полисов ОСАГО для быстрого и выгодного оформления полиса.',
    reward: {
      amount: 'до 15%',
      hint: 'от стоимости полиса',
    },
    image: osagoImg,
    partnersImgs: OSAGO_PARTNERS_IMGS,
  },
  {
    id: 3,
    title: 'Подбор кредита и займа',
    desc: [
      'Сервис позволяет выбрать лучшие предложения\nот ведущих банков России в режиме онлайн. ',
      'Предложения на основе кредитного рейтинга,\nс высоким процентом одобрения.',
    ],
    short: 'Сервис позволяет выбрать лучшие предложения от ведущих банков России в режиме онлайн.',
    reward: {
      amount: 'до 350 ₽',
    },
    image: creditImg,
    partnersImgs: CREDIT_PARTNERS_IMGS,
  },
  {
    id: 4,
    title: 'Страхование туристов',
    desc: [
      'Покупка полиса ВЗР на выгодных условиях со страховой суммой от 30 000 до 100 000 $/€. ',
      'Доступные инструменты — White Label\nи реферальная ссылка.',
    ],
    short: 'Покупка полиса ВЗР на выгодных условиях со страховой суммой от 30 000 до 100 000 $/€.',
    reward: {
      amount: 'до 25%',
      hint: 'от стоимости полиса',
    },
    image: travelInsuranceImg,
    partnersImgs: TRAVEL_INSURANCE_IMGS,
  },
  {
    id: 5,
    title: 'Страхование от несчастного случая',
    desc: [
      'Покупка полиса для участия в соревнованиях или\nпри занятии экстремальными видами спорта.',
      'Доступные инструменты — White Label\nи реферальная ссылка.',
    ],
    short: 'Сервис для выбора оптимальных и выгодных полисов от несчастных случаев.',
    reward: {
      amount: 'до 5%',
      hint: 'от стоимости полиса',
    },
    image: accidentInsuranceImg,

    partnersImgs: ACCIDENT_INSURANCE_IMGS,
  },
  {
    id: 6,
    title: 'Страхование ипотеки',
    desc: [
      'Сервис оформления страхового полиса на ипотеку позволяет сравнить и купить полис онлайн по\nсамой выгодной цене.',
      'Доступные инструменты — White Label\nи реферальная ссылка.',
    ],
    short: 'Сервис для выбора оптимальных полисов на ипотеку по выгодной цене.',
    reward: {
      amount: 'до 24%',
      hint: 'от стоимости полиса',
    },
    image: mortgageInsuranceImg,
    partnersImgs: MORTGAGE_INSURANCE_IMGS,
  },
  {
    id: 7,
    title: 'Страхование недвижимости',
    desc: [
      'Сервис позволяет выбрать лучшие предложения\nот ведущих банков России в режиме онлайн. ',
      'Предложения на основе кредитного рейтинга,\nс высоким процентом одобрения.',
    ],
    short: 'Сервис для выбора оптимальных и выгодных полисов для страхования недвижимости.',
    reward: {
      amount: 'до 30%',
      hint: 'от стоимости полиса',
    },
    image: propertyInsuranceImg,
    partnersImgs: PROPERTY_INSURANCE_IMGS,
  },
  {
    id: 8,
    title: 'Подбор кредитных карт',
    desc: [
      'Сервис помогает клиентам сравнить подходящие предложения, исходя из заполненной анкеты,\nи подобрать наиболее выгодные условия.',
      'Доступные инструменты — White Label\nи реферальная ссылка.',
    ],
    short: 'Сервис для выбора оптимальных и выгодных предложений по кредитным картам.',
    reward: {
      amount: 'до 2000 ₽',
    },
    image: creditCardImg,
    partnersImgs: CREDIT_CARD_IMGS,
  },
];

export const cardColors: CardProps['color'][] = ['green', 'blue', 'violet', 'orange'];
